var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("App版本管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageSerch" },
          [
            _c(
              "el-card",
              { staticClass: "box-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "cardTitle" }, [
                      _vm._v("App版本列表"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "版本" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入版本号",
                                  },
                                  model: {
                                    value: _vm.ruleForm.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "name", $$v)
                                    },
                                    expression: "ruleForm.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择状态" },
                                    model: {
                                      value: _vm.ruleForm.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "status", $$v)
                                      },
                                      expression: "ruleForm.status",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "停用", value: "0" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "启用", value: "1" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getList()
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                staticStyle: { "margin-bottom": "16px" },
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.add()
                  },
                },
              },
              [_vm._v("添加")]
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                ref: "scrollTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "id", label: "编号", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "APP端", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.useType == 0 ? "用户端" : "保安端"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "versionNo", label: "版本", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "分类", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(scope.row.appType == 0 ? "安卓" : "IOS")
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "发布时间", align: "center", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [_vm._v(_vm._s(scope.row.releaseAt))]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "强制", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.isForce == 0
                            ? _c("span", { staticClass: "redColor" }, [
                                _vm._v("否"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.isForce == 1
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("是"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "状态", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.status == 0
                            ? _c("span", { staticClass: "redColor" }, [
                                _vm._v("停用"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 1
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("启用"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", align: "center", width: "230" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "disAround" }, [
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.down(scope.row)
                                  },
                                },
                              },
                              [_vm._v("下载链接")]
                            ),
                            _vm._v(" "),
                            scope.row.status == 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn greenColor1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.stop(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                启用\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.status == 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn redColor1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.stop(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                停用\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.edit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn redColor1",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteItem(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n                删除\n              ")]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.pageSize,
                layout: "total, prev, pager, next,sizes",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.fullscreenLoading,
              expression: "fullscreenLoading",
            },
          ],
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "600px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticStyle: { margin: "0 auto" },
              attrs: {
                "label-position": "right",
                model: _vm.ruleForm1,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "App端", prop: "useType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.SelectType },
                      model: {
                        value: _vm.ruleForm1.useType,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm1, "useType", $$v)
                        },
                        expression: "ruleForm1.useType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "用户端", value: "0" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "保安端", value: "1" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "App分类", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.SelectSourse },
                      model: {
                        value: _vm.ruleForm1.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm1, "type", $$v)
                        },
                        expression: "ruleForm1.type",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "安卓", value: "0" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "IOS", value: "1" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "版本号", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入版本号" },
                    model: {
                      value: _vm.ruleForm1.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "name", $$v)
                      },
                      expression: "ruleForm1.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.ruleForm1.type == 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "安卓安装包", prop: "upload" } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          staticStyle: { "margin-right": "auto" },
                          attrs: {
                            action: _vm.uploadUrl,
                            headers: _vm.deader,
                            "on-success": _vm.handSuccess,
                            "before-upload": _vm.beforeAvatarUpload,
                            limit: 1,
                            "file-list": _vm.fileList,
                            accept: ".apk",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "small", type: "primary" } },
                            [_vm._v("点击上传")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.ruleForm1.type == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "IOS下载地址", prop: "upload" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: "",
                          placeholder: "请输入IOS下载地址",
                        },
                        model: {
                          value: _vm.ruleForm1.upload,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm1, "upload", $$v)
                          },
                          expression: "ruleForm1.upload",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "版本说明", prop: "memo" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", placeholder: "请输入版本说明" },
                    model: {
                      value: _vm.ruleForm1.memo,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "memo", $$v)
                      },
                      expression: "ruleForm1.memo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { display: "flex", "align-items": "center" },
                  attrs: { label: "发布状态", prop: "type" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.ruleForm1.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm1, "status", $$v)
                        },
                        expression: "ruleForm1.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("停用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { display: "flex", "align-items": "center" },
                  attrs: { label: "强制更新", prop: "type" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.ruleForm1.upDates,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm1, "upDates", $$v)
                        },
                        expression: "ruleForm1.upDates",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.resetForm1("ruleForm")
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticStyle: { "text-align": "center" },
          attrs: {
            title: "APP下载链接",
            visible: _vm.dialogFormVisible1,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible1 = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: { placeholder: "请输入内容", disabled: true },
            model: {
              value: _vm.link,
              callback: function ($$v) {
                _vm.link = $$v
              },
              expression: "link",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { margin: "20px auto", display: "inline-block" },
              on: {
                click: function ($event) {
                  return _vm.copy(_vm.link)
                },
              },
            },
            [_vm._v("复制")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }